<template>
  <div>
    <div class="hader">
      <p>
        <span>{{ Number(anIndex) + 1 }}</span>
        <span>[{{ TestItems.Style }}]</span>
        <span v-html="TestItems.Title"></span>
      </p>
    </div>
    <div class="main">
      <template v-if="!practice">
        <el-input
          type="textarea"
          placeholder="请输入答题"
          v-model="UserAnswer"
          maxlength="500"
          show-word-limit
          @change="saveAnswer"
        >
        </el-input>
      </template>
      <template v-else>
        <el-input
          type="textarea"
          placeholder="请输入答题"
          v-model="UserAnswer"
          maxlength="500"
          show-word-limit
        >
        </el-input>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      UserAnswer: "",
    };
  },
  props: ["TestItems", "anIndex", "userAbswerArr", "practice"],
  methods: {
    // 保存答案
    saveAnswer() {
      const AbswerObj = {
        TestID: this.TestItems.TestID,
        ChildTableID: this.TestItems.TestID,
        Score: this.TestItems.Score,
        UserAnswer: this.UserAnswer == "" ? null : this.UserAnswer,
        IsRight: false, // 填空、简答、解析题全部默认错误
      };
      this.$emit("userAbswer", AbswerObj);
    },
    // 回显用户刷新保存上次答案
    theEchoAbswer() {
      setTimeout(() => {
        this.userAbswerArr.forEach((item) => {
          if (item.TestID == this.TestItems.TestID) {
            this.UserAnswer = item.UserAnswer;
          }
        });
      }, 500);
    },
  },
  created() {
    this.theEchoAbswer();
  },
};
</script>

<style lang="scss" scoped>
.hader {
  min-height: 68px;
  display: flex;
  // align-items: center;
  background: #f7f7f7;
  user-select: none;
  padding: 12px 24px;
  p {
    text-align: left;
    span {
      &:nth-child(1) {
        color: #119ce5;
        font-weight: bold;
        font-size: 150%;
        margin: 0px 14px 18px 0px;
      }
      &:nth-child(2) {
        color: #119ce5;
        font-weight: bold;
      }
    }
  }
}
.main {
  padding: 36px 30px;
  user-select: none;
  ::v-deep .el-textarea__inner {
    height: 300px;
  }
}
</style>
